import { render, staticRenderFns } from "./Article-edit.vue?vue&type=template&id=5bdb4078&scoped=true"
import script from "./Article-edit.vue?vue&type=script&lang=js"
export * from "./Article-edit.vue?vue&type=script&lang=js"
import style0 from "./Article-edit.vue?vue&type=style&index=0&id=5bdb4078&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb4078",
  null
  
)

export default component.exports